var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.block)?_c('h' + _vm.block.attrs.level,{tag:"component",class:( _obj = {}, _obj['color-' + _vm.block.attrs.textColor] = true, _obj[_vm.block.attrs.fontSize] = true, _obj[_vm.block.attrs.className
				? _vm.block.attrs.className
				: 'no-style'] = true, _obj ),domProps:{"innerHTML":_vm._s(_vm.block.attrs.text)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }